"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadWithWebpack = exports.DEFAULT_MODULE = void 0;
var tslib_1 = require("tslib");
exports.DEFAULT_MODULE = './Index';
var loadWithWebpack = function (scope, module) {
    if (module === void 0) { module = exports.DEFAULT_MODULE; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var container, factory, Module;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    container = window === null || window === void 0 ? void 0 : window[scope];
                    if (!(container === null || container === void 0 ? void 0 : container.init) || !(container === null || container === void 0 ? void 0 : container.get))
                        return [2 /*return*/, null];
                    return [4 /*yield*/, __webpack_init_sharing__('default')];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, container.init(__webpack_share_scopes__.default)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, container.get(module)];
                case 3:
                    factory = _a.sent();
                    Module = factory();
                    return [2 /*return*/, Module];
            }
        });
    });
};
exports.loadWithWebpack = loadWithWebpack;
//# sourceMappingURL=loadWithWebpack.js.map